import { render, staticRenderFns } from "./MonitoringAdminDashboard.vue?vue&type=template&id=71ba704b&"
import script from "./MonitoringAdminDashboard.vue?vue&type=script&lang=js&"
export * from "./MonitoringAdminDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports